import { cities } from "./cities";
import trans from "../index";

// `cities.js`'s Egypt block (country id 65) keys its districts by the same
// numeric state id used throughout POI's Country/State/City picker, but only
// carries ids — no governorate names. This maps each EgyptGovernorates label
// (see constants/index.js) to that id so Markaz can read the exact same
// dataset POI's City dropdown uses, instead of a separate/inconsistent list.
const EGYPT_GOVERNORATE_STATE_IDS = {
	Cairo: 3223,
	Giza: 3239,
	Alexandria: 3235,
	Dakahlia: 3245,
	Sharqia: 5067,
	Qalyubia: 3232,
	Gharbia: 3234,
	Beheira: 3241,
	"Kafr el-Sheikh": 3222,
	Damietta: 3224,
	"Port Said": 3229,
	Ismailia: 3244,
	Suez: 3233,
	"North Sinai": 3227,
	"South Sinai": 3237,
	"Red Sea": 3240,
	Faiyum: 3238,
	"Beni Suef": 3230,
	Minya: 3243,
	Asyut: 3236,
	Sohag: 3226,
	Qena: 3247,
	Luxor: 3242,
	Aswan: 3225,
	Matrouh: 3231,
	"New Valley": 3246,
	Monufia: 3228,
};

const egyptCitiesByStateId = () => {
	const egypt = cities.find((c) => c.id === 65);
	return new Map((egypt?.states || []).map((s) => [s.id, s.cities || []]));
};

const CITIES_BY_STATE_ID = egyptCitiesByStateId();

// Markaz/city options for a given EgyptGovernorates label — same names and
// coordinates POI's own City dropdown would show for that governorate.
// `value` stays the raw English name (the stable, persisted key everywhere
// this feeds into — POI.city, Village.markaz, etc.); `label` is localized
// client-side via trans(), same as EgyptGovernorates, from the Arabic names
// content.js already carries for every markaz (no backend involved).
export const getMarkazOptions = (governorateName) => {
	const stateId = EGYPT_GOVERNORATE_STATE_IDS[governorateName];
	if (!stateId) return [];
	return (CITIES_BY_STATE_ID.get(stateId) || []).map((c) => ({
		label: trans(c.name),
		value: c.name,
		lat: Number(c.latitude),
		lon: Number(c.longitude),
	}));
};

// Approximate governorate center — centroid of its known cities/districts,
// derived from the same real dataset (no external lookup needed).
export const getGovernorateCenter = (governorateName) => {
	const options = getMarkazOptions(governorateName);
	if (options.length === 0) return null;
	const sum = options.reduce(
		(acc, o) => ({ lat: acc.lat + o.lat, lon: acc.lon + o.lon }),
		{ lat: 0, lon: 0 },
	);
	return { lat: sum.lat / options.length, lon: sum.lon / options.length };
};
